import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { FC, forwardRef, useEffect, useRef } from "react";
import MyResultSection from "../result/MyResultSection";
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type AddScrtinySectionProps={
    openModal:boolean;
    handleCloseModal:()=>void;
    refreshList:()=>void;
}
const AddScrtinySection:FC<AddScrtinySectionProps> = ({openModal,handleCloseModal,refreshList}):JSX.Element => {
  return (
    <div>
      <Dialog
        fullScreen
        open={openModal}
        onClose={handleCloseModal}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ ml: 4, flex: 1 }} variant="h6" component="div">
              Raise Objection
            </Typography>
            <div className="flex items-center justify-end">
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleCloseModal}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <div className="px-2 py-5">
          <MyResultSection fromScrutinyCreate refreshList={refreshList} />
        </div>
      </Dialog>
    </div>
  );
}

export default AddScrtinySection
